import styled from "styled-components";

export const Button = styled.button`
  background: #3e8dff;
  border-color: transparent;
  border-radius: 4px;
  border: 2px solid currentColor;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-family: Montserrat;
  font-size: 15px;
  font-weight: 500;
  justify-content: center;
  line-height: 1.4;
  max-height: 60px;
  padding: 8px;
  position: relative;
  transition: all 0.2s ease;
  white-space: nowrap;
  width: 100%;
`;

export const PrimaryButton = styled(Button)`
  background: ${({ loading }) => (loading ? "rgb(235, 237, 240)" : "#63da9a")};
  flex: 2;
`;

export const Cta = styled(PrimaryButton)`
  width: 100%;
  margin: 32px auto;
  cursor: pointer;
  ${p => p.disabled && "background-color: #cdcdcd"}
`;
